import { SHStack } from "@components/design-systems";
import { MAAnalysisDataDTO } from "@models/managed-accounts/entities/step/fee";
import { FeatureAnalysisRowLevel } from "@models/platform-analysis/enums/feature/featureAnalysisRowLevel";
import { AnalysisVariable } from "@models/platform-analysis/enums/variableName";
import { useTheme } from "@mui/material";
import { memo, useMemo } from "react";
import { RenderedSubProductCellComponentMap } from "../../../../configs";

interface RenderedSubProductCellContainerProps {
  analysisData?: MAAnalysisDataDTO;
  level: FeatureAnalysisRowLevel;
  forceCellColor?: `#${string}`;
  variableName?: AnalysisVariable;
}

export const RenderedSubProductCellContainer = memo(
  ({
    analysisData,
    level,
    forceCellColor,
    variableName,
  }: RenderedSubProductCellContainerProps) => {
    const { palette } = useTheme();

    const cellBackGroundColor =
      forceCellColor && level !== FeatureAnalysisRowLevel.Section
        ? `${forceCellColor} !important`
        : "inherit";

    const RenderCellComponent = useMemo(
      () => RenderedSubProductCellComponentMap[level],
      [level],
    );

    return (
      <SHStack
        className={`FeatureAnalysisRenderedCell FeatureAnalysisRenderedCell-${level}`}
        width={"100%"}
        height={"100%"}
        border={`1px solid ${palette.secondary[100]}`}
        borderBottom={"none"}
        borderLeft={"none"}
        justifyContent={"center"}
        alignItems={"center"}
        bgcolor={cellBackGroundColor}
      >
        {analysisData && (
          <RenderCellComponent
            analysisData={analysisData}
            variableName={variableName}
          />
        )}
      </SHStack>
    );
  },
);
